const attemptPlan = [
  {
    lesson_id: "W1L1",
    attempts: [
      { attempt: 1, overall: 58, creativity: 64, clarity: 52, task_completion: 58 },
      { attempt: 2, overall: 66, creativity: 69, clarity: 62, task_completion: 67 },
    ],
  },
  {
    lesson_id: "W1L2",
    attempts: [
      { attempt: 1, overall: 63, creativity: 70, clarity: 56, task_completion: 63 },
    ],
  },
  {
    lesson_id: "W1L3",
    attempts: [
      { attempt: 1, overall: 70, creativity: 74, clarity: 66, task_completion: 70 },
    ],
  },
  {
    lesson_id: "W1L4",
    attempts: [
      { attempt: 1, overall: 63, creativity: 70, clarity: 60, task_completion: 59 },
      { attempt: 2, overall: 73, creativity: 78, clarity: 70, task_completion: 71 },
    ],
  },
  {
    lesson_id: "W2L1",
    attempts: [
      { attempt: 1, overall: 74, creativity: 76, clarity: 72, task_completion: 74 },
    ],
  },
  {
    lesson_id: "W2L2",
    attempts: [
      { attempt: 1, overall: 65, creativity: 70, clarity: 63, task_completion: 62 },
      { attempt: 2, overall: 74, creativity: 75, clarity: 72, task_completion: 75 },
    ],
  },
  {
    lesson_id: "W2L3",
    attempts: [
      { attempt: 1, overall: 81, creativity: 82, clarity: 79, task_completion: 82 },
    ],
  },
  {
    lesson_id: "W2L4",
    attempts: [
      { attempt: 1, overall: 83, creativity: 82, clarity: 81, task_completion: 86 },
    ],
  },
  {
    lesson_id: "W3L1",
    attempts: [
      { attempt: 1, overall: 84, creativity: 84, clarity: 84, task_completion: 84 },
    ],
  },
  {
    lesson_id: "W3L2",
    attempts: [
      { attempt: 1, overall: 68, creativity: 72, clarity: 66, task_completion: 66 },
      { attempt: 2, overall: 86, creativity: 86, clarity: 87, task_completion: 85 },
    ],
  },
  {
    lesson_id: "W3L3",
    attempts: [
      { attempt: 1, overall: 78, creativity: 77, clarity: 78, task_completion: 79 },
    ],
  },
  {
    lesson_id: "W3L4",
    attempts: [
      { attempt: 1, overall: 91, creativity: 89, clarity: 92, task_completion: 92 },
    ],
  },
  {
    lesson_id: "W4L1",
    attempts: [
      { attempt: 1, overall: 81, creativity: 80, clarity: 82, task_completion: 81 },
    ],
  },
  {
    lesson_id: "W4L2",
    attempts: [
      { attempt: 1, overall: 72, creativity: 72, clarity: 73, task_completion: 71 },
    ],
  },
  {
    lesson_id: "W4L3",
    attempts: [
      { attempt: 1, overall: 92, creativity: 91, clarity: 93, task_completion: 92 },
    ],
  },
  {
    lesson_id: "W4L4",
    attempts: [
      { attempt: 1, overall: 89, creativity: 88, clarity: 88, task_completion: 89 },
    ],
  },
];

const progressScenarioOrder = [
  "new_student",
  "week1_mid",
  "week1_complete",
  "week2_complete",
  "week3_complete",
  "course_complete",
];

function normalizeFocusPart(value) {
  const text = String(value || "").trim().toLowerCase();
  if (!text) return null;
  if (text.includes("task") || text.includes("momentum")) return "Task Completion";
  if (text.includes("clarity")) return "Clarity";
  if (text.includes("creativity")) return "Creativity";
  if (text.includes("editorial")) return "Task Completion";
  if (text === "balanced") return "Balanced";
  return String(value || "").trim();
}

function getLessonFocusMetrics(lesson) {
  const raw = String(lesson?.rubric_focus || "Balanced");
  const parts = raw
    .split(">")
    .map(normalizeFocusPart)
    .filter(Boolean);
  const unique = [];
  parts.forEach((part) => {
    if (!unique.includes(part)) unique.push(part);
  });
  if (unique.length === 0) unique.push("Balanced");
  return {
    primary: unique[0] || null,
    secondary: unique[1] || null,
    tertiary: unique[2] || null,
  };
}

function flattenCurriculumLessons(curriculum) {
  const weeks = Array.isArray(curriculum?.weeks) ? curriculum.weeks : [];
  return weeks.flatMap((week) => {
    const weekNum = Number(week?.week);
    const lessons = Array.isArray(week?.lessons) ? week.lessons : [];
    return lessons.map((lesson) => {
      const lessonNum = Number(lesson?.lesson);
      const lessonId = lesson?.id || `W${weekNum}L${lessonNum}`;
      return {
        lesson_id: lessonId,
        week: weekNum,
        lesson: lessonNum,
        topic: lesson?.topic || lesson?.title || `Lesson ${lessonNum}`,
        task: lesson?.task || lesson?.task_base || "",
        learning_objective: lesson?.learning_objective || lesson?.objective || "",
        rubric_focus: lesson?.rubric_focus || "Balanced",
        focus_metrics: getLessonFocusMetrics(lesson),
      };
    });
  });
}

function fallbackLessons() {
  return attemptPlan.map((plan) => {
    const [, week, lesson] = plan.lesson_id.match(/^W(\d+)L(\d+)$/) || [];
    return {
      lesson_id: plan.lesson_id,
      week: Number(week),
      lesson: Number(lesson),
      topic: plan.lesson_id,
      task: "DEV sample task",
      learning_objective: "DEV sample learning objective",
      rubric_focus: "Balanced",
      focus_metrics: { primary: "Balanced", secondary: null, tertiary: null },
    };
  });
}

function scoreToRubric(score) {
  return {
    creativity: Math.round((score.creativity / 10) * 10) / 10,
    clarity: Math.round((score.clarity / 10) * 10) / 10,
    task_completion: Math.round((score.task_completion / 10) * 10) / 10,
  };
}

function scoreCategory(score) {
  if (score >= 90) return "Excellent";
  if (score >= 80) return "Good";
  return "Just Pass";
}

function bestAttempt(attempts) {
  return attempts.reduce((best, attempt) => (
    !best || attempt.overall > best.overall ? attempt : best
  ), null);
}

function makeTrendLesson(lesson, plan, index) {
  const attempts = plan.attempts.map((attempt, attemptIndex) => ({
    ...attempt,
    index: index + attemptIndex,
    submission_id: 9000 + index + attemptIndex,
    lesson_id: lesson.lesson_id,
    week: lesson.week,
    lesson: lesson.lesson,
    label: `${lesson.lesson_id} · A${attempt.attempt}`,
    created_at: `2026-06-${String(index + attemptIndex).padStart(2, "0")}T10:00:00`,
    topic: lesson.topic,
    focus_metrics: lesson.focus_metrics,
  }));
  const best = bestAttempt(attempts);
  return {
    lesson_id: lesson.lesson_id,
    week: lesson.week,
    lesson: lesson.lesson,
    topic: lesson.topic,
    rubric_focus: lesson.rubric_focus,
    focus_metrics: lesson.focus_metrics,
    attempts,
    final: best,
    overall: best?.overall,
    creativity: best?.creativity,
    clarity: best?.clarity,
    task_completion: best?.task_completion,
    score_category: scoreCategory(best?.overall || 0),
  };
}

function makeTrendLessons(curriculum, count) {
  const lessons = flattenCurriculumLessons(curriculum);
  const byId = new Map((lessons.length ? lessons : fallbackLessons()).map((lesson) => [lesson.lesson_id, lesson]));
  let attemptIndex = 1;
  return attemptPlan.slice(0, count).map((plan) => {
    const lesson = byId.get(plan.lesson_id) || fallbackLessons().find((item) => item.lesson_id === plan.lesson_id);
    const trendLesson = makeTrendLesson(lesson, plan, attemptIndex);
    attemptIndex += plan.attempts.length;
    return trendLesson;
  });
}

function flattenAttemptPoints(trendLessons) {
  return trendLessons.flatMap((lesson) => lesson.attempts);
}

function finalLessonPoints(trendLessons) {
  return trendLessons.map((lesson, index) => ({
    ...lesson.final,
    index: index + 1,
  }));
}

function completedFeedback(trendLesson) {
  const scores = trendLesson.final || {};
  return {
    comments: "DEV sample feedback: this lesson is marked completed for panel testing.",
    rubric_json: {
      scores_0_to_10: scoreToRubric(scores),
    },
  };
}

function makeWeeks(curriculum, completedThrough, trendLessons) {
  const curriculumLessons = flattenCurriculumLessons(curriculum);
  const lessons = curriculumLessons.length ? curriculumLessons : fallbackLessons();
  const byWeek = new Map();
  const trendById = new Map(trendLessons.map((lesson) => [lesson.lesson_id, lesson]));
  lessons.forEach((lesson) => {
    if (!byWeek.has(lesson.week)) byWeek.set(lesson.week, []);
    byWeek.get(lesson.week).push(lesson);
  });
  return Array.from(byWeek.entries()).map(([week, weekLessons]) => ({
    week,
    lessons: weekLessons.map((lesson) => {
      const completed = lesson.week < completedThrough.week ||
        (lesson.week === completedThrough.week && lesson.lesson <= completedThrough.lesson);
      const trendLesson = trendById.get(lesson.lesson_id);
      return {
        lesson: lesson.lesson,
        topic: lesson.topic,
        task: lesson.task,
        learning_objective: lesson.learning_objective,
        rubric_focus: lesson.rubric_focus,
        draft_text: completed ? `DEV sample submission for ${lesson.lesson_id}.` : null,
        final_text: completed ? `DEV sample final draft for ${lesson.lesson_id}.` : null,
        submission_id: completed ? trendLesson?.final?.submission_id || null : null,
        feedback: completed && trendLesson ? completedFeedback(trendLesson) : null,
      };
    }),
  }));
}

function trendArrow(points, key) {
  if (points.length < 2) return "flat";
  const latest = points[points.length - 1]?.[key];
  const previous = points[points.length - 2]?.[key];
  if (typeof latest !== "number" || typeof previous !== "number") return "flat";
  const delta = latest - previous;
  if (delta > 0.4) return "up";
  if (delta < -0.4) return "down";
  return "flat";
}

function trajectoryStatus(points) {
  if (points.length < 2) return "insufficient_data";
  const recent = points.slice(-3);
  const first = recent[0]?.overall;
  const last = recent[recent.length - 1]?.overall;
  if (typeof first !== "number" || typeof last !== "number") return "insufficient_data";
  const delta = last - first;
  if (delta >= 2) return "improving";
  if (delta <= -2) return "declining";
  return "plateauing";
}

function latestScoresPerLesson(trendLessons) {
  return trendLessons.map((lesson) => ({
    week: lesson.week,
    lesson: lesson.lesson,
    attempt: lesson.final?.attempt,
    rubric_score: lesson.final?.overall,
    label: lesson.lesson_id,
  }));
}

function makeDashboardJson(curriculum, name, completedThrough, trendCount) {
  const trendLessons = makeTrendLessons(curriculum, trendCount);
  const finalPoints = finalLessonPoints(trendLessons);
  return {
    student: {
      student_id: "DEV_PROGRESS",
      name: "DEV Progress Test",
      role: "student",
      joined_at: "2026-06-01T00:00:00",
    },
    summary: {
      latest_score_per_lesson: latestScoresPerLesson(trendLessons),
      completed_lessons: trendCount,
      total_lessons: attemptPlan.length,
      dominant_weak_area: finalPoints.length ? "Clarity" : null,
      trend_arrows: {
        overall: trendArrow(finalPoints, "overall"),
        creativity: trendArrow(finalPoints, "creativity"),
        clarity: trendArrow(finalPoints, "clarity"),
        task_completion: trendArrow(finalPoints, "task_completion"),
      },
      current_scaffolding_level: trendCount <= 4 ? "high" : trendCount >= 12 ? "low" : "med",
      trajectory_status: trajectoryStatus(finalPoints),
      trend_scores: {},
      has_data: finalPoints.length > 0,
    },
    trend: {
      points: finalPoints,
      attempt_points: flattenAttemptPoints(trendLessons),
      lessons: trendLessons,
      has_data: finalPoints.length > 0,
    },
    weeks: makeWeeks(curriculum, completedThrough, trendLessons),
    dev_scenario_name: name,
  };
}

function makeScenario(curriculum, name, progressJson, completedThrough, trendCount) {
  return {
    progressJson,
    dashboardJson: makeDashboardJson(curriculum, name, completedThrough, trendCount),
  };
}

function buildProgressScenarios(curriculum) {
  // TODO: Add explicit retry/fail-forward visual states after panel design is approved.
  return {
    new_student: makeScenario(curriculum, "new_student", { week: 1, lesson: 1 }, { week: 0, lesson: 0 }, 0),
    week1_mid: makeScenario(curriculum, "week1_mid", { week: 1, lesson: 2 }, { week: 1, lesson: 1 }, 1),
    week1_complete: makeScenario(curriculum, "week1_complete", { week: 2, lesson: 1 }, { week: 1, lesson: 4 }, 4),
    week2_complete: makeScenario(curriculum, "week2_complete", { week: 3, lesson: 1 }, { week: 2, lesson: 4 }, 8),
    week3_complete: makeScenario(curriculum, "week3_complete", { week: 4, lesson: 1 }, { week: 3, lesson: 4 }, 12),
    course_complete: makeScenario(curriculum, "course_complete", { week: 5, lesson: 1 }, { week: 4, lesson: 4 }, 16),
  };
}

export { buildProgressScenarios, getLessonFocusMetrics, progressScenarioOrder };
